declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
    _ccRun?: boolean;
  }
}

// Initialize dataLayer
window.dataLayer = window.dataLayer || [];

// Initialize gtag
function gtag(...args: any[]) {
  window.dataLayer.push(args);
}
window.gtag = gtag;

// Default consent settings
export const defaultConsentSettings = {
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied',
  'analytics_storage': 'denied',
  'functionality_storage': 'denied',
  'personalization_storage': 'denied',
  'security_storage': 'granted',
};

// Initialize Google tag with default consent settings
export const initializeGoogleConsent = () => {
  gtag('consent', 'default', {
    ...defaultConsentSettings,
    'wait_for_update': 500
  });

  gtag('set', 'ads_data_redaction', true);
  gtag('set', 'url_passthrough', true);

  // Initialize Google tag (replace with your actual measurement ID)
  gtag('js', new Date());
  gtag('config', 'G-LD53SPH1Y2', {
    'debug_mode': true // Remove this in production
  });
};

// Update consent settings based on user preferences
export const updateConsentSettings = (categories: {
  advertisement?: boolean;
  analytics?: boolean;
  functional?: boolean;
}) => {
  gtag('consent', 'update', {
    'ad_storage': categories.advertisement ? 'granted' : 'denied',
    'ad_user_data': categories.advertisement ? 'granted' : 'denied',
    'ad_personalization': categories.advertisement ? 'granted' : 'denied',
    'analytics_storage': categories.analytics ? 'granted' : 'denied',
    'functionality_storage': categories.functional ? 'granted' : 'denied',
    'personalization_storage': categories.functional ? 'granted' : 'denied',
    'security_storage': 'granted', // Always granted as it's necessary
  });
};
